<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © ISP Cloud.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Desenvolvido por ISP Cloud.
                </div>
            </div>
        </div>
    </div>
</footer>
